<template>
  <div id="hres81x-index">
    <div class="animated fadeIn" v-show="!flgProcess">
      <template v-if="msgError === ''">
        <div id="index-detail">
          <div class='box-print clearfix'>
            <div class="col-xs-6 col-md-8 company-logo no-padding"><img :src="baseUrl + 'file_uploads/Company_Logo/' + blockIndex.codcompny + '.png'" v-if="typeof blockIndex.codcompny !== 'undefined' && blockIndex.codcompny !== ''"> {{ blockIndex.desc_codcompny }}</div>
            <!-- <div class="col-xs-6 col-md-8 company-logo no-padding"><img :src="'http://203.154.162.167:8080/_payslip_img/phc/' + blockIndex.codcompny + '.png'" v-if="typeof blockIndex.codcompny !== 'undefined' && blockIndex.codcompny !== ''"> {{ blockIndex.desc_codcompny }}</div> -->
            <div class="col-xs-6 col-md-4 printer" @click="togglePrint()" v-if="dispPrint"><i class="fa fa-print"></i> Print Payslip</div>
          </div>
          <div class='box box-primary'>
            <div class="box-header with-border box-header-collapse" data-widget="collapse" @click="toggleDetailBoxIndex()">
              <i :class="'icon-minus fa fa-' + [ detailBoxIndexDisp ? 'minus' : 'plus' ]"></i>
              <h3 class="box-title"><i class="fa fa-file-text margin-r-5"></i> {{ blockIndex.codempid }} - {{ blockIndex.desc_codempid }}</h3>
            </div>
            <div class="box-body animated fadeIn" v-show="detailBoxIndexDisp">
              <div class='clearfix'>
                <div class='pull-left panel-left text-bold'>{{ labels['HRES81XCM']['15'] }}</div>
                <div class='panel-right inline-block'>
                  <div class='right-text-index detail'>{{ blockIndex.position }}</div>
                </div>
              </div>
              <div class='clearfix'>
                <div class='pull-left panel-left text-bold'>{{ labels['HRES81XCM']['16'] }}</div>
                <div class='panel-right inline-block'>
                  <div class='right-text-index detail'>{{ blockIndex.department }}</div>
                </div>
              </div>
              <div class='clearfix'>
                <div class='pull-left panel-left text-bold'>{{ labels['HRES81XCM']['80'] }}</div>
                <div class='panel-right inline-block'>
                  <div class='right-text-index detail'>{{ setDateOutput(blockIndex.paymentdate) }}</div>
                </div>
              </div>
              <div class='clearfix'>
                <div class='pull-left panel-left text-bold'>{{ labels['HRES81XCM']['60'] }}</div>
                <div class='panel-right inline-block'>
                  <div class='right-text-index detail'>{{ blockIndex.acc_id }}</div>
                </div>
              </div>
              <div class='clearfix'>
                <div class='pull-left panel-left text-bold'>{{ labels['HRES81XCM']['17'] }}</div>
                <div class='panel-right inline-block'>
                  <div class='right-text-index detail'>{{ setDateRangeOutput(blockIndex.periodpy) }}</div>
                </div>
              </div>
              <div class='clearfix'>
                <div class='pull-left panel-left text-bold'>{{ labels['HRES81XCM']['18'] }}</div>
                <div class='panel-right inline-block'>
                  <div class='right-text-index detail'>{{ blockIndex.periodal }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class='box box-primary'>
            <div class="box-header with-border box-header-collapse" data-widget="collapse" @click="toggleDetailBox1()">
              <i :class="'icon-minus fa fa-' + [ detailBox1Disp ? 'minus' : 'plus' ]"></i>
              <h3 class="box-title"><i class="fa fa-bitcoin margin-r-5"></i> {{ labels['HRES81XCM']['245'] }}</h3>
            </div>
            <div class="box-body animated fadeIn" v-show="detailBox1Disp">
              <!-- Earning -->
              <div>
                <div class='text-header color-skin'>{{ labels['HRES81XCM']['90'] }}</div>

                <div class='clearfix'></div>

                <template v-if="block3.suminc">
                  <!-- Earning -->
                  <template v-for="(amtinc, index) in block.amtinc">
                    <div class='clearfix item-list'>
                      <div class='pull-left panel-left text-detail'>{{ block['codinc'][index] }}</div>
                      <div class='panel-right inline-block'>
                        <div class='right-text'>{{ amtinc }} {{ labels['HRES81XCM']['120'] }}</div>
                      </div>
                    </div>
                  </template>

                  <!-- Total Earning -->
                  <div class='clearfix item-list'>
                    <div class='txt-label pull-left panel-left'>{{ labels['HRES81XCM']['210'] }}</div>
                    <div class='panel-right inline-block'>
                      <div class='right-text txt-label'>{{ block3.suminc }} {{ labels['HRES81XCM']['120'] }}</div>
                    </div>
                  </div>
                </template>
              </div>

              <!-- Deduction -->
              <div>
                <div class='text-header color-skin'>{{ labels['HRES81XCM']['110'] }}</div>

                <div class='clearfix'></div>

                <template v-if="block3.sumpay">
                  <!-- Deduction -->
                  <template v-for="(amtpay, index) in block1.amtpay">
                    <div class='clearfix item-list'>
                      <div class='pull-left panel-left text-detail'>{{ block1['codded'][index] }}</div>
                      <div class='panel-right inline-block'>
                        <div class='right-text'>{{ amtpay }} {{ labels['HRES81XCM']['120'] }}</div>
                      </div>
                    </div>
                  </template>

                  <!-- Total Deduction -->
                  <div class='clearfix item-list'>
                    <div class='txt-label pull-left panel-left'>{{ labels['HRES81XCM']['220'] }}</div>
                    <div class='panel-right inline-block'>
                      <div class='right-text txt-label'>{{ block3.sumpay }} {{ labels['HRES81XCM']['120'] }}</div>
                    </div>
                  </div>
                </template>
              </div>
            </div>

            <div class="box-footer animated fadeIn" v-show="detailBox1Disp">
              <!-- Net Pay -->
              <div>
                <div class='clearfix'>
                  <div class='pull-left panel-left'>{{ labels['HRES81XCM']['245'] }}</div>
                  <div class='panel-right inline-block'>
                    <div class='right-text'>{{ block3.salary }} {{ labels['HRES81XCM']['120'] }}</div>
                  </div>
                </div>
                <div class='clearfix'>
                  <div class='pull-left panel-left'>{{ labelsHres81x['net_pay_by_currency'] }}</div>
                  <div class='panel-right inline-block'>
                    <div class='right-text'>{{ block3.sumnet }} {{ labels['HRES81XCM']['120'] }}</div>
                  </div>
                </div>
                <div class='clearfix'>
                  <div class='pull-left panel-left'>{{ labelsHres81x['net_pay'] }}</div>
                  <div class='panel-right inline-block'>
                    <div class='right-text'>{{ block3.sumnet_e }} {{ labels['HRES81XCM']['120'] }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Others -->
          <div class='box box-primary'>
            <div class="box-header with-border box-header-collapse" data-widget="collapse" @click="toggleDetailBox2()">
              <i :class="'icon-minus fa fa-' + [ detailBox2Disp ? 'minus' : 'plus' ]"></i>
              <h3 class="box-title"><i class="fa fa-info-circle margin-r-5"></i> {{ labels['HRES81XCM']['130'] }}</h3>
            </div>
            <div class="box-body animated fadeIn" v-show="detailBox2Disp">
              <!-- OT Detail -->
              <template v-if="block2.qtysmot">
                <template v-for="(qtysmot, index) in block2.qtysmot">
                  <template v-if="qtysmot != ':'">
                    <div class='clearfix'>
                      <div class="pull-left panel-left">
                        {{ block2['desot'][index] }} {{ block2['rteot'][index] }}
                      </div>
                      <div class="panel-right inline-block">
                        <div class="right-text detail">
                          {{ block2['qtysmot'][index] }} {{ block2['hrs'][index] }}
                        </div>
                      </div>
                    </div>
                  </template>
                </template>
                <br>
              </template>

              <div class='clearfix'>
                <div class='pull-left panel-left'>{{ labels['HRES81XCM']['140'] }}</div>
                <div class='panel-right inline-block'>
                  <div class='right-text detail'>{{ block3.vacation }} {{ labels['HRES81XCM']['270'] }}</div>
                </div>
              </div>

              <div class='clearfix'>
                <div class='pull-left panel-left'>{{ labels['HRES81XCM']['150'] }}</div>
                <div class='panel-right inline-block'>
                  <div class='right-text detail'>{{ block3.qtywrk }} {{ labels['HRES81XCM']['270'] }}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- Ytd Amount -->
          <div class='box box-primary'>
            <div class="box-header with-border box-header-collapse" data-widget="collapse" @click="toggleDetailBox3()">
              <i :class="'icon-minus fa fa-' + [ detailBox3Disp ? 'minus' : 'plus' ]"></i>
              <h3 class="box-title"><i class="fa fa-line-chart margin-r-5"></i> {{ labels['HRES81XCM']['160'] }}</h3>
            </div>
            <div class="box-body animated fadeIn" v-show="detailBox3Disp">
              <div class='clearfix'>
                <div class='pull-left panel-left'>{{ labels['HRES81XCM']['170'] }}</div>
                <div class='panel-right inline-block'>
                  <div class='right-text detail'>{{ block3.amtcalt }} {{ labels['HRES81XCM']['120'] }}</div>
                </div>
              </div>
              <div class='clearfix'>
                <div class='pull-left panel-left'>{{ labels['HRES81XCM']['180'] }}</div>
                <div class='panel-right inline-block'>
                  <div class='right-text detail'>{{ block3.amttax }} {{ labels['HRES81XCM']['120'] }}</div>
                </div>
              </div>
              <div class='clearfix'>
                <div class='pull-left panel-left'>{{ labels['HRES81XCM']['190'] }}</div>
                <div class='panel-right inline-block'>
                  <div class='right-text detail'>{{ block3.amtsoc }} {{ labels['HRES81XCM']['120'] }}</div>
                </div>
              </div>
              <div class='clearfix'>
                <div class='pull-left panel-left'>{{ labels['HRES81XCM']['200'] }}</div>
                <div class='panel-right inline-block'>
                  <div class='right-text detail'>{{ block3.amtpf }} {{ labels['HRES81XCM']['120'] }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class='box box-primary'>
          <div class="box-header with-border box-header-collapse">
              <h3 class="box-title"><i class="fa fa-info-circle margin-r-5"></i> {{ labelsHres81x['no_data_found'] }}</h3>
          </div>
          <div class="box-body">
              <div class=''>{{ msgError }}</div>
          </div>
        </div>
      </template>
    </div>
    <div class="animated fadeIn" v-show="flgProcess">
      <div class="loader center"></div>
    </div>
  </div>
</template>

<script>
import assetsUtils from 'assets/js/utils'
export default {
  name: 'hres81x-index',
  data () {
    return {
      detailBoxIndexDisp: false,
      detailBox1Disp: true,
      detailBox2Disp: true,
      detailBox3Disp: true,
      toggleDetail: false,
      dispPrint: true
    }
  },
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    },
    setDateRangeOutput (date) {
      return assetsUtils.getDateRangeOutput(date)
    },
    togglePrint () {
      let sendParams = {
        blockIndex: this.blockIndex,
        block: this.block,
        block1: this.block1,
        block2: this.block2,
        block3: this.block3,
        searchIndex: this.searchIndex,
        labels: this.labels
      }
      this.postHres81xPrint({sendParams: sendParams})
    },
    toggleDetailBoxIndex () {
      this.detailBoxIndexDisp = !this.detailBoxIndexDisp
    },
    toggleDetailBox1 () {
      this.detailBox1Disp = !this.detailBox1Disp
    },
    toggleDetailBox2 () {
      this.detailBox2Disp = !this.detailBox2Disp
    },
    toggleDetailBox3 () {
      this.detailBox3Disp = !this.detailBox3Disp
    }
  },
  props: [ 'currentUser', 'nowLang', 'labels', 'labelsHres81x', 'msgError', 'blockIndex', 'block', 'block1', 'block2', 'block3', 'baseUrl', 'searchIndex', 'postHres81xPrint', 'flgProcess' ]
}
</script>



// WEBPACK FOOTER //
// index.vue?2054d060